import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Typography from '../components/Typography'
import axios from '../utils/posAxios'
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md'
import Avatar from '../components/Avatar'
import userPlaceholder from '../assets/img/users/profile.jpg'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { getPayment } from '../utils/dropdownlist'

class PosScheduleSlotForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      isCopy: false,
      allow_onlymod: 0,
      slot_id: '',
      schedule_id: '',
      starttime: '',
      endtime: '',
      max_slot: '',
    }
  }

  componentDidMount() {
    console.log(this.props.data)
    let data = this.props.data
    if (this.props.data.isEdit || this.props.data.isCopy) {
      let slot_data = this.props.data.slot.find(x => x[data.selectedType] === this.props.data.selectedId)
      this.setState({
        isEdit: data.isEdit,
        isCopy: data.isCopy,
        slot_id: data.selectedId,
        schedule_id: data.schedule_id,
        starttime: slot_data.starttime,
        endtime: slot_data.endtime,
        max_slot: data.selectedType == 'slotmod_id' ? slot_data.mod_slot : slot_data.max_slot,
        date: data.allow_onlymod ? slot_data.date : '',
        allow_onlymod: data.allow_onlymod,
      })
    } else {
      this.setState({
        schedule_id: this.props.data.schedule_id,
        allow_onlymod: data.allow_onlymod,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (!this.state.isEdit) {
      if (this.state.allow_onlymod == 1) {
        this.createMod(user, comp, url)
      } else {
        this.createSlot(user, comp, url)
      }
    } else {
      if (this.state.allow_onlymod == 1) {
        this.editMod(user, comp, url)
      } else {
        this.editSlot(user, comp, url)
      }
    }
  }

  createSlot(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      schedule_id: this.state.schedule_id,
      starttime: this.state.starttime,
      endtime: this.state.endtime,
      max_slot: this.state.max_slot,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/schedule/slots/create', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New slot added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  createMod(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      schedule_id: this.state.schedule_id,
      starttime: this.state.starttime,
      endtime: this.state.endtime,
      date: this.state.date,
      max_slot: this.state.max_slot,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/schedule/slots/createmod', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New slot added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  editSlot(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      slot_id: this.state.slot_id,
      starttime: this.state.starttime,
      endtime: this.state.endtime,
      max_slot: this.state.max_slot,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v1/schedule/slots/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Slot updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  editMod(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      slotmod_id: this.state.slot_id,
      max_slot: this.state.max_slot,
      date: this.state.date,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v1/schedule/slots/mod/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Slot updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Schedule Slot</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Start Time</Label>
                <Input type="time" name="starttime" value={this.state.starttime} onChange={this.changeHandler} disabled={this.state.isEdit && this.state.allow_onlymod} required />
              </FormGroup>
              <FormGroup>
                <Label>End Time</Label>
                <Input type="time" name="endtime" value={this.state.endtime} onChange={this.changeHandler} disabled={this.state.isEdit && this.state.allow_onlymod} required />
              </FormGroup>
              {this.state.allow_onlymod == 1 && (
                <FormGroup>
                  <Label>Date</Label>
                  <Input type="date" name="date" value={this.state.date} onChange={this.changeHandler} required />
                </FormGroup>
              )}
              <FormGroup>
                <Label>{this.state.allow_onlymod == 1 ? 'Mod Slot' : 'Max Slot'}</Label>
                <Input type="number" name="max_slot" value={this.state.max_slot} onChange={this.changeHandler} required />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosScheduleSlotForm
